import { LoanCriteria, LoanStatus } from '@nemuru-eng/js-api-client';

export const getLoanCriteriaProcessStatus = (loan: LoanCriteria) => {
  const currentProfessionalDetailsExists =
    loan.borrowerUserDetailsOnOrigination && loan.borrowerUserDetailsOnOrigination.professionalDetails;

  const loanAppSelectedContract =
    loan.loanApplicationSelected && loan.loanApplicationSelected.loanLenderBorrowerContract;

  const incomeData = loan.borrowerBankReaderId !== null || loan.declaredIncomeId !== null;

  switch (loan.status) {
    case LoanStatus.STATUS_INITIAL:
      if (incomeData && currentProfessionalDetailsExists && loan.originationRiskValuesId) {
        return LoanStatus.STATUS_RISK_SET;
      }
      if (currentProfessionalDetailsExists) {
        return LoanStatus.STATUS_PROFESSIONAL_DETAILS_SET;
      }
      if (loan.borrowerCashInCashOutMethodId) {
        return LoanStatus.STATUS_RISK_SET;
      }
      if (incomeData) {
        return LoanStatus.STATUS_INCOME_SET;
      }
      if (loan.borrowerUserDetailsOnOrigination) {
        return LoanStatus.STATUS_KYC_SET;
      }
      if (loan.borrowerId) {
        return LoanStatus.STATUS_OPENED;
      }
      return LoanStatus.STATUS_INITIAL;

    case LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED:
      if (loanAppSelectedContract && loanAppSelectedContract.isSent) {
        return LoanStatus.STATUS_CONTRACT_SENT;
      }
      return LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED;
    default:
      return loan.status;
  }
};
